import React, { useEffect, useState } from 'react';

import { BudgetSlpResponse } from '../../../../models/BudgetSlpResponse';
import Button from '../../../common/Button';
import { DateTime } from 'luxon';
import { EanURL } from '../../../../common/eanUtils';
import ForecastLineChart from './ForecastLineChart';
import Loader from '../../../common/Loader';
import ModalMeterBudgetWizardAdvice from '../../../modals/ModalMeterBudgetWizardAdvice';
import { OVERVIEW_TABS } from '../../../../enum/OverviewTabsEnums';
import { routes } from '../../../../routes';
import { uiState } from '../../../../atoms/uiAtom';
import { useNavigate } from 'react-router-dom';
import { useSetRecoilState } from 'recoil';
import { useTranslation } from 'react-i18next';
import { useUpdateAccount } from '../../../../hooks/accounts';

export interface MeterForecastWizardStep2Props {
  budgetSlp?: BudgetSlpResponse[];
  sdpId?: string;
}
export default function MeterForecastWizardStep2({
  budgetSlp,
  sdpId,
}: MeterForecastWizardStep2Props) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const {
    mutateAsync: updateAccount,
    isPending: IsPendingUpdateAccount,
    isError: IsErrorUpdateAccount,
  } = useUpdateAccount();
  const [isOpenAdviceModal, setIsOpenAdviceModal] = useState(false);
  const setUiState = useSetRecoilState(uiState);

  useEffect(() => {
    setUiState((state) => ({
      ...state,
      hasError: IsErrorUpdateAccount,
    }));
  }, [IsErrorUpdateAccount, setUiState]);

  const handleClickAdvice = () => {
    setIsOpenAdviceModal(true);
  };

  const handleClickActionModal = () => {
    setIsOpenAdviceModal(false);
  };

  const handleClickNext = () => {
    updateAccount({ onboardingDone: true }).then(() => {
      navigate(
        `${routes.withArgs(
          `${routes.OVERVIEW.path}${routes.OVERVIEW.children.OVERVIEW_DETAIL.path}`,
          {
            ':id': EanURL.encrypt(sdpId!) as string,
            ':tabId': OVERVIEW_TABS.FORECAST,
          }
        )}${window.location.search}`,
        { state: { fromWizard: true } }
      );
    });
  };

  return (
    <div className="meter-forecast__wizard__step">
      <h1 className="meter-forecast__wizard__step__title">
        {t('overview.meter.detail.forecast.wizard.step2.title')}
      </h1>
      <p className="meter-forecast__wizard__step__description">
        {t('overview.meter.detail.forecast.wizard.step2.description')}
      </p>

      <p role="button" onClick={handleClickAdvice} className="meter-forecast__wizard__step__info">
        {t('overview.meter.detail.forecast.wizard.step2.info')}
      </p>
      <ForecastLineChart
        data={budgetSlp?.map((item) => ({
          x: DateTime.fromISO(item.time)
            .minus({
              hours: 1,
            })
            .toMillis(),
          y: item.value,
        }))}
      />

      <div className="meter-forecast__wizard__footer">
        <a
          href={t('common.faq.link')}
          target="_blank"
          className="btn btn--secondary"
          rel="noreferrer"
        >
          {t('overview.meter.detail.forecast.question')}
        </a>
        <Button
          onClick={handleClickNext}
          className="btn btn--primary"
          isDisabled={IsPendingUpdateAccount}
          prefix={IsPendingUpdateAccount ? <Loader /> : null}
        >
          {t('common.next')}
        </Button>
      </div>
      <ModalMeterBudgetWizardAdvice
        isOpen={isOpenAdviceModal}
        onClickAction={handleClickActionModal}
      />
    </div>
  );
}
